import React from "react";
import { useLoaderData } from "react-router-dom";

const Single = () => {
	const single = useLoaderData();
	console.log(single);
	return (
		<section className="single mb-10">
			<div className="container mx-auto">
				<div className="bg-neutral rounded-xl p-10">
					<h2 className="text-4xl text-center text-primary py-10">More Information Of Product</h2>

					<div className="hero ">
						<div className="hero-content flex-col lg:flex-row gap-4">
							<img
								src={single.image}
								className="max-w-sm rounded-lg shadow-2xl"
								alt={single.title}
							/>
							<div className="px-10">
								<h1 className="text-5xl font-bold"> {single.title}</h1>
								<p className="py-6">{single.description}</p>
								<p className="badge badge-primary text-xl py-4 my-4">
									{single.category}
								</p>
								<p className="text-accent text-2xl my-4"> ${single.price}</p>

								<div className="card-actions my-5">
									<button className="btn btn-secondary">Add To Cart</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Single;
